// extracted by mini-css-extract-plugin
export default {"bolded":"style--bolded--2de604"};